import { Center, Container, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import type { Contract } from '@/api/generated/models';
import type { StatusHistoryEntry } from '@/features/history/statusHistoryTypes';
import { useGetContract, useGetContractHistory } from '@/api/generated/contracts/contracts';
import { ContractStatus } from '@/api/generated/models/contractStatus';
import { BackButton, ContentCard } from '@/components/common';
import { statusConfig } from '@/features/contracts/contractDisplay';
import { StatusHistoryTable } from '@/features/history/components/StatusHistoryTable';

export const ContractHistoryPage = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { data: contractData, isLoading: isLoadingContract } = useGetContract(id ?? '', {
    query: { enabled: !!id }
  });
  const contract = contractData as Contract | undefined;
  const { data: historyData, isLoading: isLoadingHistory } = useGetContractHistory(id ?? '', {
    query: { enabled: !!id }
  });
  const entries = (historyData as StatusHistoryEntry[] | undefined) ?? [];

  const resolveStatus = (raw: string) => {
    const config = statusConfig[raw as ContractStatus];
    return config
      ? { label: t(config.labelKey), bg: config.bg, fg: config.fg }
      : { label: raw, bg: 'var(--color-bg-surface-2)', fg: 'var(--color-text-secondary)' };
  };

  if (isLoadingContract || isLoadingHistory || !contract) {
    return (
      <Container size="lg" px={0}>
        <Center py={80}>
          <Loader size="sm" />
        </Center>
      </Container>
    );
  }

  return (
    <Container size="lg" px={0}>
      <Stack gap={24}>
        <BackButton to={`/contracts/${id}`} />
        <Text fz={14} fw={600} style={{ color: 'var(--color-text-secondary)' }}>
          {contract.contractNumber ?? contract.referenceId}
        </Text>
        <ContentCard>
          <div style={{ padding: 20 }}>
            <StatusHistoryTable entries={entries} resolveStatus={resolveStatus} />
          </div>
        </ContentCard>
      </Stack>
    </Container>
  );
};
